angular.module('picmonicng').factory('PathwayService', [
  '$cookies',
  'Pathways',
  function ($cookies, Pathways) {
    var PathwayService = {
      pathway: {},
    };

    return PathwayService;
  },
]);
